import React, { memo, VFC, useState, useEffect, useCallback } from 'react';
import {
  Center,Spinner,Text,Divider,Input,
  Table,Thead,Tbody,Tr,Th,Td,Flex,Box,VStack,
} from '@chakra-ui/react';
// import { ExternalLinkIcon } from '@chakra-ui/icons';
import { ListButton } from '../atoms/button/ListButton';
import { SearchInput } from '../atoms/input/SearchInput';
import { useIssue } from '../../hooks/useIssue';
import { ErrorDialog } from '../organisms/modal/ErrorDialog';
import { useLoginUser } from "../../hooks/providers/useLoginUserProvider";
import { NoticeDetailDialog } from '../organisms/modal/NoticeDetailDialog';
import { noticeObj, searchParam } from '../../types/issue';
import { useOpelog } from '../../hooks/useOpelog';
import { PrimaryButton } from "../../components/atoms/button/PrimaryButton";

export const NoticeTable: VFC = memo(() => {

  const { loginUser } = useLoginUser();
  const [ noticeObjList, setNoticeObjList ] = useState<Array<noticeObj>>([]);
  const { getNoticeListResult, executing, errObj, getNoticeList } = useIssue();
  const [ searchParam, setSearchParam ] = useState<searchParam>({
    username: '',
    userGroup: '',
    fromDate: '',
    toDate: '',
    buName: '',
    custName: '',
    blankFlag: false,
    cloud_type: '',
    noticeKind: '',
    eval_key: {},
  });
  const [ execFlag, setExecFlag ] = useState(false);
  const { OutputOpelog } = useOpelog();
  const [ closeFlag, setCloseFlag ] = useState(false);

  // API実行準備
  useEffect(() => {
    setExecFlag(true);
  }, []);
    
  // API実行準備
  useEffect(() => {
    if( execFlag && searchParam.fromDate && searchParam.toDate ){
      setExecFlag(false);
      getNoticeList(searchParam);
      OutputOpelog( 'notice_mail_list', 'reference', '');
    }
  }, [execFlag, searchParam]);
  
  // 検索実行
  const execSearch = useCallback(() => {
    searchParam.eval_key = {};
    setNoticeObjList([]);
    getNoticeList(searchParam);
  },[searchParam]);
  
  // 次を取得
  const getNext = useCallback(() => {
    getNoticeList(searchParam);
    
  }, [searchParam]);
  
  useEffect(() => {
    if( getNoticeListResult !== null ){
      setNoticeObjList([...noticeObjList,...getNoticeListResult.mailgroup_list]
        .sort((a,b)=>{
          if( a.send_day < b.send_day ) return 1;
          if( a.send_day > b.send_day ) return -1;
          if( a.cloud_type < b.cloud_type ) return 1;
          if( a.cloud_type > b.cloud_type ) return -1;
          return 0;
        }));
      searchParam.eval_key = getNoticeListResult.eval_key;
    }    
  }, [getNoticeListResult]);


  return (
    <>
      {errObj && !closeFlag ? (
        <ErrorDialog errTitle="通知メール" errObj={errObj} opeErrMes="" setCloseFlag={setCloseFlag} />
      ) : (
        <>
          <SearchInput
            func='notice'
            searchParam={searchParam}
            setSearchParam={setSearchParam}
            defaultSearchDays={loginUser.mailgroup_search_days}
            maxSearchDays={loginUser.max_mail_search_days}
            cloud_list={loginUser.mailgroup_cloud_list}
            executing={executing}
            execSearch={execSearch}
          />
          <Divider orientation="horizontal" mt="10px" />
          {/* 以下リスト */}
          {executing ? (
            <Center h="20vh">
              <Spinner color="teal.500" />
            </Center>
          ) : (
            <VStack>
              <NoticeTableSub noticeObjList={noticeObjList} nextStr={Object.keys(searchParam.eval_key).length ? '＋' : ''} />
              {searchParam !== null && typeof searchParam === 'object' &&
               typeof searchParam.eval_key === 'object' && Object.keys(searchParam.eval_key).length !== 0 &&
                <PrimaryButton type='ng' onClick={getNext} isLoading={executing}>続きを追加</PrimaryButton>
              }
            </VStack>
          )}
        </>
      )}
    </>
  );
});

type PropsSub = {
  noticeObjList: Array<noticeObj>; // レコードデータ
  nextStr: string;
};

export const NoticeTableSub: VFC<PropsSub> = memo((props) => {
  const { noticeObjList, nextStr } = props;
  const [ noticeId, setNoticeId ] = useState('');
  
  const [ filterCloud, setFilterCloud ] = useState('');
  const [ filterClass, setFilterClass ] = useState('');
  const [ filterFrom, setFilterFrom ] = useState('');
  const [ filterTitle, setFilterTitle ] = useState('');
  const [ filterAccount, setFilterAccount ] = useState('');
  const [ noticeObjListTmp, setNoticeObjListTmp ] = useState<Array<noticeObj>>([]);
    
  // 検索絞り込み
  useEffect(() => {
    setNoticeObjListTmp([...
      noticeObjList.filter((item:noticeObj)=>{
      return(
        (filterCloud  === '' || item.cloud_type.indexOf(filterCloud) >= 0) &&
        (filterClass  === '' || item.class_name.indexOf(filterClass) >= 0) &&
        (filterFrom   === '' || item.from_kind.indexOf(filterFrom) >= 0) &&
        (filterTitle  === '' || item.title.indexOf(filterTitle) >= 0) &&
        (filterAccount=== '' || item.account_list.join(',').indexOf(filterAccount) >= 0)
      )})
    ]);
    
  }, [noticeObjList,filterCloud,filterClass,filterFrom,filterTitle,filterAccount]);

  return (
    <>
      <Box id="case" margin="30px">
        <Flex alignItems="flex-end">
          <Text fontSize="lg">
            ■メール一覧（{noticeObjList.length}件{nextStr}）
          </Text>
        </Flex>
        {/* 以下メール一覧リスト */}
        <Table id="table-mail-group-detail" border="1" colorScheme="gray" variant="striped" size="sm">
          <Thead background="#aaaaaa">
            <Tr>
            <Th color="white" fontSize="sm">No.</Th>
            <Th color="white" fontSize="sm">通知日</Th>
            <Th color="white" fontSize="sm">クラウド種別<Input id="filterCloud" onChange={(e)=>setFilterCloud(e.target.value)} value={filterCloud} size='xs' placeholder="部分一致" /></Th>
            <Th color="white" fontSize="sm">分類<Input id="filterClass" onChange={(e)=>setFilterClass(e.target.value)} value={filterClass} size='xs' placeholder="部分一致" /></Th>
            <Th color="white" fontSize="sm">送信元<Input id="filterFrom" onChange={(e)=>setFilterFrom(e.target.value)} value={filterFrom} size='xs' placeholder="部分一致" /></Th>
            <Th color="white" fontSize="sm">タイトル<Input id="filterTitle" onChange={(e)=>setFilterTitle(e.target.value)} value={filterTitle} size='xs' placeholder="部分一致" /></Th>
            <Th color="white" fontSize="sm">アカウントID(お客様名)<Input id="filterAccount" onChange={(e)=>setFilterAccount(e.target.value)} value={filterAccount} size='xs' placeholder="完全一致" /></Th>
            <Th color="white" fontSize="md"></Th>
          </Tr>
          </Thead>
          <Tbody>
            {noticeObjListTmp.map((item:noticeObj,index:number) => (
              <Tr key={index} verticalAlign="top">
                <Td>{index+1}</Td>
                <Td>{item.send_day}</Td>
                <Td>{item.cloud_type}</Td>
                <Td>{item.class_name}</Td>
                <Td>{item.from_kind}</Td>
                <Td>{item.title}</Td>
                <Td>{item.account_list.map((item:string) => (
                   <Text key={item} align="left">{item}</Text>
                ))}</Td>
                <Td>
                  <ListButton onClick={()=>setNoticeId(item.mail_group_id)}>詳細</ListButton>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
      {noticeId !== '' && (
        <NoticeDetailDialog noticeId={noticeId} setNoticeId={setNoticeId} />
      )}
    </>
  );
});